module.exports = __webpack_public_path__ + "img/bancaubi-logo.ee5636ff.jpg";